import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'react-bootstrap';

import FilterSelector from 'components/search_sidebar/filter_selector';

export default class TagsFilter extends React.Component {

  static propTypes = {
    availableTags: PropTypes.array.isRequired,
    canManageTags: PropTypes.bool,
    excludeTags: PropTypes.bool.isRequired,
    selectedTags: PropTypes.array.isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onSelectAllChange: PropTypes.func.isRequired,
    onSelectExcludeTags: PropTypes.func.isRequired,
    onSelectManageTags: PropTypes.func
  };

  static defaultProps = {
    canManageTags: false,
  }

  state = {
    searchText: "",
    selectAllState: false
  };

  isChecked = (value) => {
    return this.props.selectedTags.indexOf(value) >= 0;
  }

  handleSelect = (e) => {
    const { onAdd } = this.props;
    const tag = e.target.value;
    this.isChecked(tag) ? this.handleOnRemove(tag) : onAdd(tag);
  }

  handleOnRemove = (tag) => {
    const { onRemove } = this.props;
    const { selectAllState } = this.state;

    if (selectAllState) {
      this.setState({
        selectAllState: false
      });
    }

    onRemove(tag);
  }

  handleExclude = (tag) => {
    const { onAdd, onRemove } = this.props;
    this.isChecked(tag) ? onRemove(tag) : onAdd(tag);
  }

  handleSearchChange = (e) => {
    this.setState({
      searchText: e.target.value
    });
  }

  manageSelectAll = () => {
    const { onSelectAllChange, availableTags, onAdd } = this.props;
    const { selectAllState } = this.state;
    const selectAllValue = !selectAllState;


    this.setState({
      selectAllState: selectAllValue
    });

    if (selectAllValue) {
      availableTags.forEach((tag) => {
        this.isChecked(tag) ? '' : onAdd(tag);
      });
    } else {
      onSelectAllChange();
    }
  }

  manageExcludeTags = (e) => {
    const value = e.target.value;
    const { excludeTagsState } = this.state;
    const excludeTagsValue = excludeTagsState.includes(value) ? [] : [value];

    this.setState({
      excludeTagsState: excludeTagsValue
    });
  }

  renderTagOptions = () => {
    const { searchText } = this.state;
    const { availableTags } = this.props;

    return availableTags.map((tag) => {
      if (tag.toLowerCase().includes(searchText.toLowerCase())) {
        return (
          <div className="filter-checkbox" key={tag}>
            <Checkbox
              checked={this.isChecked(tag)}
              inline={true}
              value={tag}
              onChange={this.handleSelect}
            >
              {tag}
            </Checkbox>
          </div>
        );
      }
    }).filter(Boolean);
  }

  render() {
    const { canManageTags, excludeTags, onSelectExcludeTags, onSelectManageTags } = this.props;
    const { searchText, selectAllState } = this.state;

    const tagOptions = this.renderTagOptions();

    return (
      <React.Fragment>
        <FilterSelector
          searchText={searchText}
          searchTextPlaceHolder="Search tags"
          onSearchChange={this.handleSearchChange}
        >
          <div className="select-all-checkbox">
            <Checkbox
              checked={selectAllState}
              value={'select_all'}
              onChange={this.manageSelectAll}
            >
              Select All
            </Checkbox>
          </div>
          {tagOptions.length > 0 ? tagOptions : <span className="text-muted">No matching tags found</span>}

          <Checkbox
            checked={excludeTags}
            value={'exclude_tags'}
            onChange={onSelectExcludeTags}
          >
            (No Tag)
          </Checkbox>
        </FilterSelector>
        {canManageTags &&
          <div className="contact-link clickable" onClick={onSelectManageTags}>
            Manage Tags
          </div>
        }
      </React.Fragment>
    );
  }
}
